import React from 'react';
import { Stack, Grid } from '@mui/material';
import InputLabel from 'components/form/InputLabel';
import OutlinedInput from 'components/form/OutlinedInput';
import ControlledAutocomplete from 'components/form/Autocomplete';
import ControlledSwitch from 'components/form/Switch';
import DateTextField from 'components/form/DateTextField';
import CpfCnpjTextField from 'components/form/CpfCnpjTextField';

const DadosDaCredencial = ({ formProps, banksDomain }) => {
  const tipoSelecionado = formProps.watch('tipo');
  const isSantander = tipoSelecionado?.id === 'santander';
  const isItau = tipoSelecionado?.id === 'itau';

  const labelClientId = isSantander ? 'pgcom' : 'Client ID';
  const labelClientSecret = isSantander ? 'usercode' : 'Client Secret';
  const labelApiId = isSantander ? 'UTM_SOURCE' : 'API ID';
  const labelLogin = isSantander ? 'enc' : isItau ? 'PDV' : 'Login';

  return (
    <Grid container spacing={2}>
      {/* Linha 1: Banco, Descrição */}
      <Grid item xs={12} md={3}>
        <Stack spacing={0}>
          <InputLabel htmlFor="tipo">Banco</InputLabel>
          <ControlledAutocomplete
            formProps={formProps}
            name="tipo"
            domain={banksDomain}
            idField="id"
            labelField="name"
            noOptionsText="Nenhum banco encontrado"
          />
        </Stack>
      </Grid>
      <Grid item xs={12} md={9}>
        <Stack spacing={0}>
          <InputLabel htmlFor="descricao">Descrição</InputLabel>
          <OutlinedInput
            id="descricao"
            name="descricao"
            placeholder="Descrição da credencial"
            fullWidth
            formProps={formProps}
            inputProps={{ maxLength: 100 }}
          />
        </Stack>
      </Grid>

      {/* Linha 2: CPF/CNPJ, Data de Expiração, Padrão */}
      <Grid item xs={12} md={3}>
        <Stack spacing={0}>
          <InputLabel htmlFor="cpfCnpj">CPF/CNPJ</InputLabel>
          <OutlinedInput
            id="cpfCnpj"
            name="cpfCnpj"
            type="both"
            placeholder="CPF ou CNPJ"
            fullWidth
            formProps={formProps}
            InputProps={{
              inputComponent: CpfCnpjTextField,
              maxLength: 18
            }}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} md={3}>
        <Stack spacing={0}>
          <InputLabel htmlFor="dataExpiracao">Data de Expiração</InputLabel>
          <OutlinedInput
            id="dataExpiracao"
            name="dataExpiracao"
            placeholder="DD/MM/AAAA"
            fullWidth
            formProps={formProps}
            InputProps={{
              inputComponent: DateTextField
            }}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} md={2}>
        <Stack spacing={0}>
          <InputLabel htmlFor="padrao">Padrão</InputLabel>
          <ControlledSwitch formProps={formProps} name="padrao" label="" />
        </Stack>
      </Grid>

      {/* Linha 3: Client ID, Client Secret, API ID */}
      <Grid item xs={12} md={4}>
        <Stack spacing={0}>
          <InputLabel htmlFor="clientId">{labelClientId}</InputLabel>
          <OutlinedInput
            id="clientId"
            name="clientId"
            placeholder={labelClientId}
            fullWidth
            formProps={formProps}
            inputProps={{ maxLength: 200 }}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} md={4}>
        <Stack spacing={0}>
          <InputLabel htmlFor="clientSecret">{labelClientSecret}</InputLabel>
          <OutlinedInput
            id="clientSecret"
            name="clientSecret"
            placeholder={labelClientSecret}
            fullWidth
            formProps={formProps}
            inputProps={{ maxLength: 200 }}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} md={4}>
        <Stack spacing={0}>
          <InputLabel htmlFor="apiId">{labelApiId}</InputLabel>
          <OutlinedInput
            id="apiId"
            name="apiId"
            placeholder={labelApiId}
            fullWidth
            formProps={formProps}
            inputProps={{ maxLength: 200 }}
          />
        </Stack>
      </Grid>

      {/* Linha 4: Login */}
      <Grid item xs={12}>
        <Stack spacing={0}>
          <InputLabel htmlFor="login">{labelLogin}</InputLabel>
          <OutlinedInput
            id="login"
            name="login"
            placeholder={labelLogin}
            fullWidth
            formProps={formProps}
            inputProps={{ maxLength: 2000 }}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default DadosDaCredencial;
